//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SitesSessionStorageService } from "@nuskin/ns-util";
import { NsIcon, NsAnimateHeight } from "@nuskin/design-components";

import NsHeaderProfile from "./NsHeaderProfile.vue";
import NsHeaderProfileToggle from "./NsHeaderProfileToggle.vue";

const PROFILE_CLOSED = "profileClosed";
export default {
  name: "NsHeaderProfileDropdown",
  components: {
    NsIcon,
    NsAnimateHeight,
    NsHeaderProfile,
    NsHeaderProfileToggle
  },
  props: {
    /**
     * Hides the Signup text and link
     */
    hideSignUp: Boolean,
    /**
     * List of potential navigation links
     */
    profileMenu: {
      type: Array,
      default: () => []
    },
    /**
    /**
     * The url where signout link takes you
     */
    signOutUrl: {
      type: String,
      default: ""
    },
    /**
     * The url where signup link takes you
     */
    signUpUrl: {
      type: String,
      default: ""
    },
    /**
     * Translations for component
     * Required keys: id, greeting, enjoyLoyalty, newCustomerLabel,
     * signUpTodayLabel, signIn, signOut, signUp
     */
    translations: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    dropdownOpen: !SitesSessionStorageService.getItem(PROFILE_CLOSED)
  }),
  methods: {
    handleCloseClick() {
      this.$emit("close-drawer");
    },
    handleDropdownToggle() {
      this.dropdownOpen = !this.dropdownOpen;
      SitesSessionStorageService.removeItem(PROFILE_CLOSED);
      SitesSessionStorageService.writeItem(PROFILE_CLOSED, !this.dropdownOpen);
    }
  }
};
